import React, { ReactNode } from "react";
import { Box, Flex, FlexProps, useToken } from "@chakra-ui/react";
import { PATH_PICK_SELECTION_BAR_Z_INDEX } from "@/features/pathpick/constants";

interface Props extends FlexProps {
  header: ReactNode;
  footer?: ReactNode;
  // footer를 스크롤 컨테이너 하단에 붙여둔다(기본 false — 기존 호출부는 그대로 흘러간다).
  // 전제: 스크롤 컨테이너에 하단 패딩이 없어야 한다. 패딩이 있으면 sticky 기준선이
  // 그만큼 올라가 바가 화면 바닥에서 뜬다(패스픽 페이지들의 paddingBottom: 100px 주의).
  isFooterSticky?: boolean;
}

function PathPickSectionCard({
  header,
  footer,
  isFooterSticky = false,
  children,
  ...props
}: Props) {
  const [hairlineDefault] = useToken("shadows", ["hairlineDefault"]);

  return (
    <Flex
      flexDirection={"column"}
      boxShadow={hairlineDefault}
      borderRadius={"8px"}
      {...props}
    >
      <Box
        padding={"16px"}
        paddingBottom={"8px"}
        boxShadow={"0 0.5px 0 0 #8F8F8C"}
      >
        {header}
      </Box>
      <Box
        padding={"16px"}
        paddingTop={"8px"}
        // 본문을 하나의 쌓임 맥락으로 가둬, 자식이 어떤 z-index를 쓰든
        // sticky footer 위로 올라오지 못하게 한다.
        {...(isFooterSticky
          ? { position: "relative" as const, zIndex: 0 }
          : {})}
      >
        {children}
      </Box>
      {footer && (
        <Box
          padding={"12px 16px"}
          boxShadow={"0 0.5px 0 0 #D4D4D1 inset"}
          // sticky는 가장 가까운 스크롤 조상(패스픽 페이지의 overflow Box) 기준으로 붙는다.
          // 붙는 범위가 이 카드 안으로 제한돼 목록 끝에서는 원래 자리에 안착한다.
          // 카드가 배경색을 깔지 않아 아래 내용이 비치므로 페이지 배경색을 직접 준다.
          {...(isFooterSticky
            ? {
                position: "sticky" as const,
                bottom: 0,
                // sticky + z-index는 footer를 하나의 쌓임 맥락으로 만들어, 안의 페이지 크기 드롭다운
                // (Portal 없는 Popover)은 z-index가 커도 바깥에서는 footer의 값으로만 비교된다.
                // 하단 플로팅 선택 바(fixed)보다 낮으면 드롭다운이 바 밑에 깔리므로 바보다 한 단계 위에 둔다.
                // 바는 footer 바로 위에 떠 있어 서로 겹치지 않는다.
                zIndex: PATH_PICK_SELECTION_BAR_Z_INDEX + 1,
                background: "#FCFCFE",
                borderBottomRadius: "8px",
              }
            : {})}
        >
          {footer}
        </Box>
      )}
    </Flex>
  );
}

export default PathPickSectionCard;
